import CloseIcon from '../Icons/CloseIcon'

const ButtonCloseModal = ({ handler }) => {
  return <CloseIcon handler={handler} className="btn_close" />
}

export default ButtonCloseModal
